import { Address } from '../../../../types/Common';
import { Coord } from '../../../../types/MapBox';
import { useAddressPremiumInfo } from '../api/getAddressPremiumInfo';

interface Response {
  coords: Coord[][] | undefined;
  isLoading: boolean;
}

const useAddressCoords = (address?: Address): Response => {
  const { data, isLoading } = useAddressPremiumInfo(address);
  const coordinates = data?.data?.parcel?.main_building?.coordinates;

  const mapToCoordsObject = (coordinates: number[][]): Coord[][] => {
    if (coordinates?.length > 0)
      return [coordinates.map((array) => ({ lng: array[0], lat: array[1] }))];
    return [];
  };
  return {
    coords: coordinates ? mapToCoordsObject(coordinates) : undefined,
    isLoading,
  };
};

export default useAddressCoords;
